import React from 'react';
import { useParams, useHistory } from 'react-router-dom';

const ProjectCardHome = ({ project, id, name, zip_code, gross_area, work_type, main_building_use, project_template_name, project_template_description, is_template, selectProject = null, removeProject = null, editProject = null, subscription = null, editable = true, handleSelectedRecentProject }) => {

    const history = useHistory();
    const projectMeta = `${zip_code} - ${work_type}`;

    const handleClick = () => {
        handleSelectedRecentProject(project, false);
    }

    return (
        // Utiliza la clase 'card' de Bootstrap
        <div className='row px-3' >
            <div className="card shadow-sm col-12 col-md-4" >
                <div className="card-body">

                    {/* Título del proyecto */}
                    <h5 className="card-title mb-2">
                        {name}
                    </h5>

                    {/* Metadatos del proyecto (código y tipo) */}
                    <h6 className="card-subtitle mb-3 text-muted" style={{ fontSize: '14px' }}>
                        {projectMeta}
                    </h6>

                    {/* --- Separador Visual --- */}
                    {/* <hr className="my-3" /> */}

                    {/* Contenedor para las acciones/botones */}
                    <div className="d-flex justify-content-start align-items-center">

                        {/* Acción "Ask AI" */}
                        <button
                            className="btn btn-link p-0 mr-4 text-decoration-none"
                            onClick={() => { history.push(`/chatbot?projectId=${id}&projectName=${name}`) }}
                            aria-label={`Ask AI about ${name}`}
                            style={{color:'#1a67a3'}}
                        >

                            <i class="bi bi-gear-fill"> </i>
                            Ask AI
                        </button>

                        {/* Acción "View Project" */}
                        <button
                            className="btn btn-link p-0 text-decoration-none"
                            onClick={handleClick}
                            aria-label={`View details of ${name}`}
                            style={{color:'#1a67a3'}}
                        >
                            <i class="bi bi-eye-fill"> </i>
                            View Project
                        </button>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectCardHome;